import { createFileRoute } from '@tanstack/react-router'

import { TelaEntrada } from '@/features/acesso/tela-entrada'

/** Parâmetros aceitos: `next` (para onde voltar) e `conta=sem-acesso` (aviso de conta recusada). */
type BuscaEntrar = { next?: string; conta?: string }

export const Route = createFileRoute('/entrar')({
  validateSearch: (busca: Record<string, unknown>): BuscaEntrar => ({
    next: typeof busca.next === 'string' ? busca.next : undefined,
    conta: typeof busca.conta === 'string' ? busca.conta : undefined,
  }),
  component: Entrar,
})

/** Só caminhos do próprio painel valem como destino (o servidor confere de novo). */
function destinoLocal(bruto: string | undefined): string {
  if (!bruto || !bruto.startsWith('/') || bruto.startsWith('//') || bruto.startsWith('/\\')) {
    return '/'
  }
  return bruto
}

/** Tela de entrada (`/entrar`): leva ao login Google do servidor e volta para `next`. */
function Entrar() {
  const { next, conta } = Route.useSearch()
  return (
    <TelaEntrada
      situacao={{ tipo: 'entrar', destino: destinoLocal(next), semAcesso: conta === 'sem-acesso' }}
    />
  )
}
